import React, { useState } from 'react';

const TTableGenerator = () => {
  const [startDf, setStartDf] = useState(1);
  const [endDf, setEndDf] = useState(10);
  const [tTable, setTTable] = useState([]);

  // Placeholder function to calculate t-values (replace with actual formula or data if available)
  const calculateTValue = (df, alpha) => {
    return (1 / Math.sqrt(df)) * Math.abs(Math.log(alpha)).toFixed(4); // Approximation for demonstration
  };

  const generateTTable = () => {
    if (startDf < 1 || endDf > 100 || startDf > endDf) {
      alert("Please enter a valid range (1 to 100) and ensure start is less than or equal to end.");
      return;
    }

    const table = [];
    for (let df = startDf; df <= endDf; df++) {
      table.push({
        df,
        alpha_0_10: calculateTValue(df, 0.10),
        alpha_0_05: calculateTValue(df, 0.05),
        alpha_0_01: calculateTValue(df, 0.01),
      });
    }
    setTTable(table);
  };

  return (
    <div>
      <h2>Table of t-Values</h2>
      <label htmlFor="startDf">Start Degrees of Freedom (1-100): </label>
      <input
        type="number"
        id="startDf"
        min="1"
        max="100"
        value={startDf}
        onChange={(e) => setStartDf(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="endDf">End Degrees of Freedom (1-100): </label>
      <input
        type="number"
        id="endDf"
        min="1"
        max="100"
        value={endDf}
        onChange={(e) => setEndDf(parseInt(e.target.value))}
      />
      <br />
      <button onClick={generateTTable}>Generate Table</button>

      {tTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>df</th>
              <th>t (α = 0.10)</th>
              <th>t (α = 0.05)</th>
              <th>t (α = 0.01)</th>
            </tr>
          </thead>
          <tbody>
            {tTable.map((row, index) => (
              <tr key={index}>
                <td>{row.df}</td>
                <td>{row.alpha_0_10}</td>
                <td>{row.alpha_0_05}</td>
                <td>{row.alpha_0_01}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TTableGenerator;
